export class PathBuilder {
    public static buildX(x: number, y: number, size: number): string {
        return `M ${x - size} ${y - size} L ${x + size} ${y + size} M ${x - size} ${y + size} L ${x + size} ${y - size}`;
    }
}